import Decommissioned from "./pages/Decommissioned/Decommissioned";

const App = () => {
  return <Decommissioned />;
};

export default App;
